// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../tools/HBuilderX/plugins/uniapp-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-95fec69e] .scroll-list-x{white-space:nowrap}", ""]);
// Exports
module.exports = exports;
